import { Component, OnInit, Input, PLATFORM_ID, Inject, Renderer2 } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { BreadcrumbData } from '../breadcrumb/breadcrumb.component';
import { ImageService } from '../../services/image.service';
import { PageMetaComponentBase } from '../../page-meta-component-base';
import { JssContextService } from '../../jss-context.service';
import { isPlatformServer } from '@angular/common';
import { Subscription } from 'rxjs';
import { JssStylingService } from '../../jss-styling.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-card-offer',
  templateUrl: './card-offer.component.html',
  styleUrls: ['./card-offer.component.scss']
})
export class CardOfferComponent extends PageMetaComponentBase implements OnInit {
  @Input() rendering: ComponentRendering = null;
  breadcrumbData = {} as BreadcrumbData;
  public isMobile: boolean = false;
  public image:{src:string, alt:string};
  _isPlatformServer: boolean = false;
  public contextSubscription: Subscription;
  dynamicClass: string;

  constructor( public jssStylingService: JssStylingService, private imageService: ImageService, @Inject(PLATFORM_ID) public readonly platformId: string, private jssContext: JssContextService, public renderer: Renderer2,@Inject(DOCUMENT) public document: Document) { super(renderer, platformId, document) }

  ngOnInit() {
    // remove this after implementation is done
    
    this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);
    this.contextSubscription = this.jssContext.state.subscribe((newState) => {
      this.jssState = newState;
    });
    this._isPlatformServer = isPlatformServer(this.platformId);
    let fields = this.rendering.fields as any;
    this.image = this.imageService.getImageFromResolver(fields?.result?.CardOffer);
    this.breadcrumbData.items =(this.rendering?.fields?.result as any)?.['BreadcrumbData'];
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    if (this.contextSubscription)
      this.contextSubscription.unsubscribe();
  }
}
